export const hashToId = (hash?: string): number =>
  hash ? parseInt(String(hash).replace(/[^\d]/g, '').replace(/^0/, '').slice(0, 5)) : 0;
